import {MutationCache, QueryCache, QueryClient} from '@tanstack/react-query'

import {redirectToLoginForUnauthorized} from '../auth/redirect-to-login'

function handleGlobalError(error: Error) {
    redirectToLoginForUnauthorized(error)
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Intermittent errors are rare enough that we don't need to handle
            // them with retries, and retrying requests that fail due to bugs is
            // a waste of resources and increases complexity unnecessarily.
            staleTime: Infinity,
            retry: false,
        },
    },
    queryCache: new QueryCache({onError: handleGlobalError}),
    mutationCache: new MutationCache({onError: handleGlobalError}),
})
